import { UPDATE_GET_ART_NOTIFICATION } from "helpers/url_helper";
import {
  ADD_NEWSLETTER_EMAIL_FAIL,
  ADD_NEWSLETTER_EMAIL_REQUEST,
  ADD_NEWSLETTER_EMAIL_SUCCESS,
  GET_ART_NOTIFICATION_FAIL,
  GET_ART_NOTIFICATION_REQUEST,
  GET_ART_NOTIFICATION_SUCCESS,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_FAIL,
  GET_NOTIFICATIONS_SUCCESS,
  POST_NOTIFICATION_FAIL,
  POST_NOTIFICATION_REQUEST,
  POST_NOTIFICATION_SUCCESS,
  SEND_NEWSLETTER_EMAIL_FAIL,
  SEND_NEWSLETTER_EMAIL_REQUEST,
  SEND_NEWSLETTER_EMAIL_SUCCESS,
  UPDATE_ARTNOTIFICATION_FAIL,
  UPDATE_ARTNOTIFICATION_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  notifications: [],
  totalNotifications: 0,
  category: {},
  artNotification: []
};

const Notifications = (state = INIT_STATE, action) => {
  switch (action.type) {
    /* Get Notifications */
    case GET_NOTIFICATIONS:
    case GET_ART_NOTIFICATION_REQUEST:
    case UPDATE_GET_ART_NOTIFICATION:
    case UPDATE_ARTNOTIFICATION_SUCCESS:
    case POST_NOTIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload.data || [],
        totalNotifications: action.payload.totalCount || 0,
        loading: false,
        error: "",
      };
    case GET_ART_NOTIFICATION_SUCCESS:
      return {
        ...state,
        artNotification: action.payload.data || [],
        loading: false,
        error: "",
      };
    case POST_NOTIFICATION_SUCCESS:
      return {
        loading: false,
        error: "",
      };


    case GET_NOTIFICATIONS_FAIL:
    case GET_ART_NOTIFICATION_FAIL:
    case UPDATE_ARTNOTIFICATION_FAIL:
    case POST_NOTIFICATION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    /* Get Notifications END */
    case SEND_NEWSLETTER_EMAIL_SUCCESS:
      return {
        loading: false,
        error: "",
      };


    case SEND_NEWSLETTER_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

      case SEND_NEWSLETTER_EMAIL_REQUEST:
        return {
          ...state,
          loading: true,
        };

        case ADD_NEWSLETTER_EMAIL_SUCCESS:
      return {
        loading: false,
        error: "",
      };


    case ADD_NEWSLETTER_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

      case ADD_NEWSLETTER_EMAIL_REQUEST:
        return {
          ...state,
          loading: true,
        };

    default:
      return state;
  }
};

export default Notifications;
